import { cva } from 'class-variance-authority'

export type SectionLevel = 1 | 2 | 3

export const sectionRootVariants = cva('flex flex-col', {
  variants: {
    level: {
      1: 'gap-stack',
      2: 'gap-50',
      3: 'gap-stack',
    },
  },
  defaultVariants: { level: 1 },
})

export const sectionHeaderVariants = cva('group/section-header grid', {
  variants: {
    level: {
      1: 'min-h-[32px] grid-cols-[1fr_auto] items-center gap-x-stack gap-y-20',
      2: 'grid-cols-[1fr_auto] items-center gap-x-stack gap-y-20',
      3: 'grid-cols-[1fr_auto] items-center gap-x-stack gap-y-20',
    },
  },
  defaultVariants: { level: 1 },
})

export const sectionTitleVariants = cva('', {
  variants: {
    level: {
      1: 'col-start-1 truncate',
      2: 'col-start-1',
      3: 'col-start-1 text-content-base-main',
    },
  },
  defaultVariants: { level: 1 },
})

export const sectionBodyVariants = cva('flex flex-col', {
  variants: {
    level: {
      1: 'gap-stack',
      2: 'gap-50',
      3: 'gap-stack',
    },
  },
  defaultVariants: { level: 1 },
})
